"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    transform: "translate(113.266 112.724)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-113.266 -112.724)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0,20.454c.272-1.379.466-2.8.816-4.157a21.986,21.986,0,1,1-.33,9.634C.214,24.571.155,23.192,0,21.813ZM22.026,1.224C10.858,1.244,1.437,10.47,1.34,21.308A20.7,20.7,0,1,0,22.026,1.224Z",
        transform: "translate(0 -0.025)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M58.4,41.057A11.3,11.3,0,0,1,69.342,29.794c.7-.02,1.232.139,1.251.894s-.536.954-1.212.993a9.3,9.3,0,1,0,9.595,9.972v-.4c-.02-.7.3-1.212,1.013-1.212s.973.576.934,1.251a11,11,0,0,1-3.317,7.628,11.39,11.39,0,0,1-18.772-4.708A10.707,10.707,0,0,1,58.4,41.057Z",
        transform: "translate(-47.312 -23.879)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M90.8,66.586A4.809,4.809,0,0,1,95.785,61.7a4.978,4.978,0,0,1,4.748,4.887,5.051,5.051,0,0,1-5.085,4.847A4.661,4.661,0,0,1,90.8,66.586Zm4.907,2.841a2.878,2.878,0,0,0,2.861-2.821,3,3,0,0,0-2.861-2.98,2.9,2.9,0,0,0-2.94,2.861,2.865,2.865,0,0,0,2.96,2.94Z",
        transform: "translate(-73.274 -49.796)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(7.214 29.731)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M82.8,154.839h-.536V157.4l-.2-.238-.179-.2L79.6,154.7v3.834h.536v-2.563l.159.219.179.2,2.324,2.3Z",
          transform: "translate(-71.495 -154.7)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M88.762,179.7l-.2-.238-.179-.2L86.1,177v3.834h.536v-2.563l.159.219.179.2,2.324,2.284v-3.834h-.536Z",
          transform: "translate(-76.704 -172.57)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M101.886,156.83h-1.41v-.914h1.41V155.4H99.9v3.695h.576v-1.728h1.41Z",
          transform: "translate(-87.762 -155.261)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          className: "b",
          width: "0.576",
          height: "3.691",
          transform: "translate(14.78 0.139)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M60.246,155.656A1.887,1.887,0,0,0,58.9,155.1a1.907,1.907,0,0,0-.735.139,1.927,1.927,0,0,0-1.033,1.053,2.026,2.026,0,0,0,0,1.49,1.868,1.868,0,0,0,.417.616,1.887,1.887,0,0,0,1.351.576,1.867,1.867,0,0,0,.735-.139,1.947,1.947,0,0,0,.616-.417,1.907,1.907,0,0,0,.417-.616,1.967,1.967,0,0,0-.417-2.126Zm-.139,1.907a1.371,1.371,0,0,1-.278.457,1.311,1.311,0,0,1-.417.3,1.231,1.231,0,0,1-.5.1,1.251,1.251,0,0,1-.5-.1,1.271,1.271,0,0,1-.417-.3,1.371,1.371,0,0,1-.278-.437,1.45,1.45,0,0,1-.1-.536,1.47,1.47,0,0,1,.1-.536,1.351,1.351,0,0,1,.278-.437,1.271,1.271,0,0,1,.417-.3,1.263,1.263,0,0,1,1.41.3,1.371,1.371,0,0,1,.278.457,1.45,1.45,0,0,1,.1.536,1.43,1.43,0,0,1-.1.477Z",
          transform: "translate(-53.373 -155.02)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M40.726,155a1.947,1.947,0,0,0-.755.139,1.788,1.788,0,0,0-.616.417,1.848,1.848,0,0,0-.417.636,2.172,2.172,0,0,0,0,1.53,1.828,1.828,0,0,0,.4.616,1.768,1.768,0,0,0,.616.417,2.046,2.046,0,0,0,.755.139,2.006,2.006,0,0,0,.6-.079,1.668,1.668,0,0,0,.516-.258v-.675a1.907,1.907,0,0,1-.556.358,1.609,1.609,0,0,1-.6.119,1.172,1.172,0,0,1-.914-.4,1.549,1.549,0,0,1,0-1.986,1.252,1.252,0,0,1,.954-.4,1.55,1.55,0,0,1,.576.1,1.788,1.788,0,0,1,.516.318l.04-.6a2.086,2.086,0,0,0-.556-.278A1.907,1.907,0,0,0,40.726,155Z",
          transform: "translate(-38.799 -154.939)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M131.562,179.7l-.2-.238-.179-.2L128.9,177v3.834h.536v-2.563l.159.219.179.2,2.324,2.284v-3.834h-.536Z",
          transform: "translate(-111.002 -172.57)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M158.121,155.4H155.7v.516h1.53l-1.828,3.178h2.741v-.536h-1.828Z",
          transform: "translate(-132.238 -155.261)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M171.028,154.7l-1.728,3.834h.616l.417-.953h1.41l.4.953h.616Zm-.5,2.384.358-.834.06-.2.06-.219.06.238.06.179.358.834Z",
          transform: "translate(-143.376 -154.7)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M139.662,157.4l-.2-.238-.179-.2L137,154.7v3.834h.536v-2.563l.159.219.179.2,2.324,2.3v-3.854h-.536Z",
          transform: "translate(-117.493 -154.7)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          className: "b",
          width: "0.576",
          height: "3.691",
          transform: "translate(16.329 4.569)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M107.9,177.7h-.6v3.715h1.986v-.576H107.9Z",
          transform: "translate(-93.692 -173.131)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          className: "b",
          d: "M120.263,157.58l.4.953h.616l-1.728-3.834-1.748,3.834h.616l.417-.953Zm-.834-1.331.06-.2.06-.219.06.238.06.179.358.834h-.993Z",
          transform: "translate(-102.107 -154.7)"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "b",
        d: "M150.386,178.216V177.7H148.4v3.675h1.986v-.5h-1.41v-1.232h1.41v-.516h-1.41v-.914Z",
        transform: "translate(-119.606 -143.401)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "b",
        d: "M65.963,178.391a1.947,1.947,0,0,0-.417-.636A1.887,1.887,0,0,0,64.2,177.2a1.907,1.907,0,0,0-.735.139,1.927,1.927,0,0,0-1.033,1.053,2.026,2.026,0,0,0,0,1.49,1.868,1.868,0,0,0,.417.616,1.887,1.887,0,0,0,1.351.576,1.867,1.867,0,0,0,.735-.139,1.947,1.947,0,0,0,.616-.417,1.907,1.907,0,0,0,.417-.616,2.006,2.006,0,0,0,0-1.49Zm-.556,1.271a1.371,1.371,0,0,1-.278.457,1.312,1.312,0,0,1-.417.3,1.233,1.233,0,0,1-.5.1,1.252,1.252,0,0,1-.5-.1,1.271,1.271,0,0,1-.417-.3,1.371,1.371,0,0,1-.278-.437,1.45,1.45,0,0,1-.1-.536,1.47,1.47,0,0,1,.1-.536,1.351,1.351,0,0,1,.278-.437,1.271,1.271,0,0,1,.417-.3,1.251,1.251,0,0,1,.5-.1,1.232,1.232,0,0,1,.5.1,1.252,1.252,0,0,1,.417.3,1.37,1.37,0,0,1,.278.457,1.45,1.45,0,0,1,.1.536A1.43,1.43,0,0,1,65.407,179.663Z",
        transform: "translate(-50.213 -142.999)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M90.83,52.832a8.079,8.079,0,0,0-16.13.954,7.8,7.8,0,0,0,3.635,6.377,6.57,6.57,0,0,0,3.933,1.291h.079a.983.983,0,0,0,0-1.967h-.079l-.477-.079a6.033,6.033,0,0,1-5.145-6.377,6.293,6.293,0,0,1,6.1-5.761,6.138,6.138,0,0,1,6.079,5.761c.04.755.219,1.41,1.073,1.331S90.89,53.567,90.83,52.832Z",
        transform: "translate(-60.375 -36.603)"
      })]
    })
  })
});

var ConfianzaOnline = function ConfianzaOnline(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathSolid;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '-2 -2 50 50';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "ConfianzaOnline-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = ConfianzaOnline;
exports["default"] = _default;

//# sourceMappingURL=index.js.map